import { render, staticRenderFns } from "./administrationScoreSpotReport.vue?vue&type=template&id=3c7d1e48&scoped=true&"
import script from "./administrationScoreSpotReport.vue?vue&type=script&lang=js&"
export * from "./administrationScoreSpotReport.vue?vue&type=script&lang=js&"
import style0 from "./administrationScoreSpotReport.vue?vue&type=style&index=0&id=3c7d1e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d1e48",
  null
  
)

export default component.exports